module.exports = __webpack_public_path__ + "img/img_review_sample.225db153.png";